module.exports = __webpack_public_path__ + "static/goodreads-e0d32f5362637e7868d5eec7563f69e5.png";